import React, { useEffect, useState } from "react";
import { useFormik, FieldArray } from "formik";
import * as Yup from "yup";

import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import TransactionsFilterForm from "./TransactionsFilterForm";
import { resetExtraFilters, setStoreFormValues } from "../../../store/slices/Transactions/transactionsSlice";

const useFilterForm = (setShowform) => {
  const dispatch = useDispatch();

  const {
    paymentGatewayId,
    statusId,
    startDate,
    endDate,
  } = useSelector((state) => state.transactions);
  const validationSchema = Yup.object({
    paymentGateway: Yup.object().nullable(),
    statusId: Yup.object().nullable(),
    startDate: Yup.date().nullable(),
    endDate: Yup.date().nullable(),
  });

  // Set the initial values based on whether edit is true or false
  const initialValues = {
    paymentGateway: paymentGatewayId,
    statusId: statusId,
    startDate: startDate,
    endDate: endDate,
  
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const {
        paymentGateway,
        statusId,
        startDate,
        endDate,
      } = values;

      if (
        paymentGateway === "" &&
        statusId === "" &&
        startDate === "" &&
        endDate === ""
      ) {
        toast.error("All fields are empty!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      } else {
        setShowform(false);
      }

      if (values) {
        dispatch(setStoreFormValues(values));
      }
    },
  });

  const renderTabContent = () => {
    return (
      <TransactionsFilterForm
        formik={formik}
        handleResetExtraFilters={handleResetExtraFilters}
      />
    );
  };

  const handleResetExtraFilters = () => {
    dispatch(resetExtraFilters());
    formik.resetForm();
    setShowform(false);
  };

  return {
    formik,
    renderTabContent,
    handleResetExtraFilters,
  };
};

export default useFilterForm;
